export {
  initializeInfluencerReferral,
  influencerReferralStore,
} from 'lib/influencer-referral/client';
import type { CountryGroup } from 'helpers/experiment';
import { resolveGlassLocale } from './locale';

const inFlight = new Map<string, Promise<string | null>>();
const origin =
  process.env.NEXT_PUBLIC_NAV_DISCOUNT_ORIGIN ||
  'https://pro-landing-pages.invideo.io';

/** Both landing sites use the uncached nav handler on the pro landing origin. */
export function fetchNavPricingDiscountLabel(
  group: CountryGroup,
  pageLocale?: string,
  referral?: string | null,
): Promise<string | null> {
  const resolved = resolveGlassLocale(pageLocale);
  const locale = resolved === 'pt' ? 'pt-BR' : resolved;
  const context = [group, locale];
  if (referral) context.push(referral);
  const path = context.map(encodeURIComponent).join('/');
  // Next.js redirects file-like paths to remove their trailing slash.
  const trailingSlash = /\.\w+$/.test(path) ? '' : '/';
  const url = `${origin}/api/nav-discount/${path}${trailingSlash}`;
  let request = inFlight.get(url);
  if (!request) {
    request = fetch(url, { cache: 'no-store' })
      .then(async response => {
        if (!response.ok) return null;
        const data = await response.json();
        return typeof data.label === 'string' ? data.label : null;
      })
      .catch(() => null)
      .finally(() => inFlight.delete(url));
    inFlight.set(url, request);
  }
  return request;
}
